var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VuetifyDialog',_vm._b({on:{"onToggleDialog":_vm.handleToggleDialog,"onClickAcceptButton":_vm.handleClickAcceptButton,"onClickCancelButton":_vm.handleClickCancelButton}},'VuetifyDialog',_vm.getDialogOptions,false))
}
var staticRenderFns = []

export { render, staticRenderFns }